import { Col, Row } from "antd";
import PerformanceChart from "../VendorHome/PerformanceChart";
import styles from "./Analytics.module.css";
import TextComponent from "../../../components/textComponent/TextComponent";
import { RenderMultipleTimes, reviews } from "../VendorHome/VendorHome";
import { useLocation } from "react-router-dom";
import userDummyImg from '../../../assets/dummy.jpg';

const Analytics = () => {
  const {state} = useLocation();
  console.log("statee///////////", state);
  // console.log();
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={15}>
        <TextComponent textClass={styles.performanceTitle}>
          Performance Metrics
        </TextComponent>
        <PerformanceChart height={"100%"} Analytics={state} />
      </Col>
      <Col xs={24} lg={9}>
        <TextComponent textClass={styles.feedbackTitle}>
          Customer Feedback
        </TextComponent>
        <Row className={styles.reviewsContainer}>
          <Col xs={24}>
            {state?.reviewslist?.map((review) => (
              <Row gutter={16} className={styles.singleReviewRow}>
                <Col>
                  <img src={review?.user_image ? review?.user_image : userDummyImg} className={styles.reviewImage} />
                </Col>
                <Col style={{ flexGrow: 1 }}>
                  <Row className={styles.singleReviewTitleRow}>
                    <TextComponent textClass={styles.singleReviewTitle}>
                    {review?.user_name ? review?.user_name : '--'}
                    </TextComponent>
                    <>
                      {review.rating ? (
                        <Row style={{ gap: "5px", alignItems: "center" }}>
                          <TextComponent textClass={styles.singleReviewRating}>
                            Rating: {review?.rating ? review?.rating : 0}
                          </TextComponent>
                          <RenderMultipleTimes numberOfTimes={review?.rating ? review?.rating : 0} />
                        </Row>
                      ) : (
                        ""
                      )}
                    </>
                  </Row>
                  <Row>
                    <TextComponent textClass={styles.singleReviewDesc}>
                    {review?.review ? review?.review : '--'}
                    </TextComponent>
                  </Row>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Analytics;
